// extracted by mini-css-extract-plugin
module.exports = {"callbacks-table":"_2YEc9","callbacksTable":"_2YEc9","return-type-container":"_39vRO","returnTypeContainer":"_39vRO"};